// eslint-disable-next-line import/no-anonymous-default-export
export default [
  { title: "UI/UX Designer", department: "UI Team", statusCode: 0 },
  { title: "Web Development", department: "Frontend", statusCode: 1 },
  { title: "Ushop App", department: "Mobile Team", statusCode: -1 },
  { title: "UI/UX Designer", department: "UI Team", statusCode: 0 },
  { title: "Web Development", department: "Frontend", statusCode: 1 },
  { title: "Ushop App", department: "Mobile Team", statusCode: -1 },
  { title: "UI/UX Designer", department: "UI Team", statusCode: 0 },
  { title: "Web Development", department: "Frontend", statusCode: 1 },
  { title: "Ushop App", department: "Mobile Team", statusCode: -1 },
  { title: "UI/UX Designer", department: "UI Team", statusCode: 0 },
  { title: "Web Development", department: "Frontend", statusCode: 1 },
  { title: "Ushop App", department: "Mobile Team", statusCode: -1 },
];
